export default () => import(/* webpackChunkName: 'coffee/activities/medal-wall' */ './MedalWall');
